import { render } from "./MainPageItem.vue?vue&type=template&id=1abde025&scoped=true"
import script from "./MainPageItem.vue?vue&type=script&lang=js"
export * from "./MainPageItem.vue?vue&type=script&lang=js"

import "./MainPageItem.vue?vue&type=style&index=0&id=1abde025&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abde025"]])

export default __exports__